<script>
  import DatePicker from '../DatePicker/Datepicker.svelte'
  import { faClock, faCalendar } from '@fortawesome/pro-regular-svg-icons'

  import TimePicker from '../svelte-time-picker/src/TimePicker.svelte'

  import { getContext, tick } from 'svelte'

  import dayjs from 'dayjs'
  import customParseFormat from 'dayjs/plugin/customParseFormat'
  dayjs.extend(customParseFormat)

  import writableDerived from 'svelte-writable-derived'
  import { extractDate } from '../FormElements/timeHelpers.js'

  import Icon from '../Icon/'
  import { Dropdown, DropdownContent } from '../Dropdown/'
  import { cssPrefix } from '../helper-classes.js'

  // export let elementName
  export let variant = null
  export let config = {}
  export let id = null
  export let weekStart = 0
  export let language = 'en'

  const element = getContext('currentElement')

  let tare = new Date()
  tare.setHours(0)
  tare.setMinutes(0)
  tare.setSeconds(0)

  let dateDelegate
  let minDate
  let maxDate
  let dateSelected = new Date()
  const pickerFormat = 'YYYY-MM-DD'

  const timePickerOptions = { hasButtons: false, is24h: true }
  let onTimeChange

  if (variant !== 'Native') {
    config.textType = true

    const updateElement = d => {
      tare = d
      element.setValue(dayjs(tare).format('YYYY-MM-DDTHH:mm'))
    }

    dateDelegate = writableDerived(
      element,
      state => {
        const extracted = extractDate(state.formatted[0], 'YYYY-MM-DD')
        if (extracted.date && extracted.date.getDate() !== tare.getDate()) {
          const dateWithTime = state.value ? new Date(`${extracted.iso}T${state.formatted[1]}`) : extracted.date
          updateElement(dateWithTime)
        }
        return extracted
      },
      (reflecting, old) => {
        if (!reflecting.success || !reflecting.iso) return old
        const extracted = extractDate(`${reflecting.iso}T${old.formatted[1]}`, 'YYYY-MM-DDTHH:mm')
        old.value = dayjs(extracted.date).format('YYYY-MM-DDTHH:mm')
        return old
      }
    )

    if ($element.min) minDate = extractDate($element.min, 'YYYY-MM-DD').date
    if ($element.max) maxDate = extractDate($element.max, 'YYYY-MM-DD').date

    onTimeChange = e => {
      // console.log('time changed', tare)
      if (tare.getMinutes() !== e.detail.getMinutes()) {
        tare.setMinutes(e.detail.getMinutes())
        updateElement(tare)
        dropdown.toggle()
      }
      if (tare.getHours() !== e.detail.getHours()) {
        tare.setHours(e.detail.getHours())
        updateElement(tare)
      }
    }
  }

  const layout = config.layout || getContext('formGroupLayout')
  if (layout === 'TwoCols') {
    config.blockClasses = [`${cssPrefix}form-block`, 'is-horizontal', 'has-control']
  } else {
    config.blockClasses = [`${cssPrefix}form-block`]
  }

  let dropdown
</script>

<div class={config.blockClasses && config.blockClasses.join(' ')}>
  {#if $element.label}
    <div class={`${cssPrefix}form-label`}>
      <div class={`${cssPrefix}label`} class:is-required={$element.required && !$element.disabled}>
        <label for={id}>{$element.label}</label>
      </div>
    </div>
  {/if}

  <div class={`${cssPrefix}form-field`}>
    <div class={`${cssPrefix}controls is-grouped`}>
      {#if variant === 'Native'}
        <div class={`${cssPrefix}control`}>
          <slot name="a" inputClass={$element.error ? `${cssPrefix}input has-error` : `${cssPrefix}input`} />
        </div>
      {:else}
        <div class={`${cssPrefix}control is-date ${cssPrefix}date-picker has-icons-end`}>
          <DatePicker
            start={minDate}
            end={maxDate}
            format={pickerFormat}
            on:open={() => element.onEvent(new Event('focus'))}
            on:close={() => element.onEvent(new Event('blur'))}
            on:change={() => tick().then(() => element.onEvent(new Event('change')))}
            bind:selected={dateSelected}
            bind:dateChosen={$dateDelegate.success}
            bind:formattedSelected={$dateDelegate.iso}
            {weekStart}
            {language}
          >
            <slot name="a" inputClass={$element.error ? `${cssPrefix}input has-error` : `${cssPrefix}input`} />
          </DatePicker>
          <Icon icon={faCalendar} iconClass="is-end" />
        </div>

        <div class={`${cssPrefix}control is-time time-picker has-icons-end`}>
          <Icon icon={faClock} iconClass="is-end" />
          <Dropdown bind:this={dropdown}>
            <span
              role="button"
              tabindex="0"
              on:click={() => {
                dropdown.toggle()
              }}
              on:keypress={e => {
                if (e.key === 'Enter') {
                  dropdown.toggle()
                }
              }}
            >
              <slot name="b" inputClass={$element.error ? `${cssPrefix}input has-error` : `${cssPrefix}input`} />
            </span>
            <DropdownContent narrow>
              <TimePicker date={new Date(tare.getTime())} options={timePickerOptions} on:change={onTimeChange} />
            </DropdownContent>
          </Dropdown>
        </div>
      {/if}
    </div>
  </div>

  {#if $element.info}
    <div class={`${cssPrefix}form-info`} class:has-info={$element.info}>
      <div class={`${cssPrefix}message`}>
        <p id="${id}-description">{$element.info}</p>
      </div>
    </div>
  {/if}

  {#if $element.error}
    <div class={`${cssPrefix}form-error`}>
      <div class={`${cssPrefix}message is-status-error`}>
        <p id="${id}-error">{$element.error}</p>
      </div>
    </div>
  {/if}
</div>
